import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-510b022f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main metro-no-touch-device noie fontawesome-i2svg-active fontawesome-i2svg-complete ma5menu--left hasnt-body-scrollbar"
}
const _hoisted_2 = { class: "notify-container" }
const _hoisted_3 = {
  id: "front",
  "data-front-locale": "en",
  "data-site-currency": "EUR",
  class: "h-100"
}
const _hoisted_4 = { class: "auctions-tab" }

import { onMounted } from 'vue';
import AuctionsContent from './content/AuctionsContent.vue';
import AuctionsTabs from './content/AuctionsTabs.vue';
import CheckSiteUp from './CheckSiteUp.vue';
import { ref } from 'vue';
import { Auction } from '@/types/metadata';


export default /*#__PURE__*/_defineComponent({
  __name: 'Maintenance',
  setup(__props) {

const activeTab = ref(1);
const lang = ref('de');
const hasStarted = ref(false);
const isLoading = ref(true); // Set to true initially to indicate data is being loaded
const fetchingVideo = ref(false);
const metadata = ref({auctions: [] as Auction[]});

// Fetch data from the given URL
async function fetchData() {
  try {
    const response = await fetch('https://horse24-maintenance-html.s3.amazonaws.com/domains.json');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    if (data && data.auctions) {
      const hostname = window.location.hostname;
      let auctions = data.auctions.filter(auction => auction.domain === hostname);
      if (!auctions.length) {
        auctions = data.auctions.filter(auction => auction.domain === 'horse24.com');
      }
      metadata.value = { auctions }; // Assuming the JSON structure contains a "metadata" property
    }
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error.message);
  } finally {
    isLoading.value = false; // Data loading completed (either successful or failed)
  }
}

// Fetch data when component is mounted
onMounted(() => {
  void fetchData();
});

const setActiveTab = (tabValue: number) => {
  activeTab.value = tabValue;
};

return (_ctx: any,_cache: any) => {
  return (metadata.value.auctions.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CheckSiteUp, { lang: lang.value }, null, 8, ["lang"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AuctionsTabs, {
              "active-tab": activeTab.value,
              "onUpdate:activeTab": setActiveTab,
              lang: lang.value,
              auctions: metadata.value.auctions
            }, null, 8, ["active-tab", "lang", "auctions"])
          ]),
          _createVNode(AuctionsContent, {
            "active-tab": activeTab.value,
            lang: lang.value,
            "onUpdate:lang": _cache[0] || (_cache[0] = ($event: any) => ((lang).value = $event)),
            "has-started": hasStarted.value,
            "is-loading": isLoading.value,
            "fetching-video": fetchingVideo.value,
            auctions: metadata.value.auctions
          }, null, 8, ["active-tab", "lang", "has-started", "is-loading", "fetching-video", "auctions"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})